import { createSlice } from '@reduxjs/toolkit';
import { PURGE, REHYDRATE } from 'redux-persist';
import { reporthubChartOptionKeys } from '../../../components/global/StockhubBI/chartFilterEnums';

// const initialState = {
//   searchString: '',
//   columns: [
//     {
//       column: "BLAB",
//       visible: true,
//       pinned: true,
//     }
//   ],
//   sortedBy: [],
//   filter: {
//     groups: []
//   },
// };
const initialState = {
  report: null,
  filter: {},
  overlayWidth: 0,
};

const reportFilterSlice = createSlice({
  name: 'reportFilter',
  initialState: initialState,

  reducers: {
    setReport: (state, action) => {
      state.report = action.payload;
      state.filter = {};
    },
    updateFilter: (state, action) => {
      const { filterKey, value,type } = action.payload;

      const isFirstFilter = Object.keys(state.filter).length === 0;

      if (!state.filter[filterKey]) {
        state.filter[filterKey] = {
          type,
          value,
          primary: isFirstFilter
        };
      } else {
        state.filter[filterKey].value = value;
      }
    },
    setPrimaryFilter: (state, action) => {
      const filterKey = action.payload;

      if (!state.filter[filterKey]) return;

      Object.keys(state.filter).forEach(key => {
        state.filter[key].primary = false;
      });

      state.filter[filterKey].primary = true;
    },

    removeFilter: (state, action) => {
      const filterKey = action.payload;

      const wasPrimary = state.filter[filterKey]?.primary;
      delete state.filter[filterKey];

      if (wasPrimary) {
        const keys = Object.keys(state.filter);

        if (keys.length > 0) {
          const nextKey = keys[0];
          state.filter[nextKey].primary = true;
        }
      }
    },

    resetFilter: (state,action) => {
      state = initialState;
    }
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(PURGE, () => initialState)
  //     .addCase(REHYDRATE, (state, action) => {
  //       // Or if you want to update the state with the rehydrated state:
  //       if (action.payload) {
  //         return { ...state, ...action.payload.reportFilter };
  //       }
  //       return state;
  //     })
  // }
});


export const { 
  updateFilter,
  setPrimaryFilter,
  removeFilter,
  updateOverlayWidth,
  resetFilter,
  setReport,
} = reportFilterSlice.actions;
export default reportFilterSlice;